import { render, staticRenderFns } from "./survey1.vue?vue&type=template&id=73b16c58&scoped=true&"
import script from "./survey1.vue?vue&type=script&lang=js&"
export * from "./survey1.vue?vue&type=script&lang=js&"
import style0 from "./survey1.vue?vue&type=style&index=0&id=73b16c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b16c58",
  null
  
)

export default component.exports